export default (context, inject) => {
  inject('routeParams', {
    getCountryCode: (router) => {
      return typeof router.currentRoute.params.countryCode !== 'undefined'
        ? router.currentRoute.params.countryCode
        : '' // init empty string
    }
  })
}
